import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=0dcc245c&scoped=true"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderSuccess.vue?vue&type=style&index=0&id=0dcc245c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc245c",
  null
  
)

export default component.exports